module.exports = __webpack_public_path__ + "img/ruler.8c377c45.svg";